module.exports = "/_next/static/images/dirtyBackground-f465cedc13cce64a12a158d733390573.png";